var m = require('mithril');
var Model = require('../../libs/Model');

var user = Object.create(Model)

user.name = 'User';
user['@class'] =  'User'
user.url = 'user'

user.fields = {
  isSuperuser: {
    type: 'select',
    default: 0,
    validators: {
      presence: true
    },
    options: [
      {name: 'Yes', value: 1},
      {name: 'No', value: 0}
    ]
  },
  isReportAdmin: {
    type: 'select',
    default: 0,
    validators: {
      presence: true
    },
    options: [
      {name: 'Yes', value: 1},
      {name: 'No', value: 0}
    ]
  },
  isCalibrationSuperuser: {
    type: 'select',
    default: 0,
    validators: {
      presence: true
    },
    options: [
      {name: 'Yes', value: 1},
      {name: 'No', value: 0}
    ]
  }
};

module.exports = user;
